import React from 'react';

export const FaceAnxietyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M15 16.5C15 18.9853 12.9853 21 10.5 21C8.01472 21 6 18.9853 6 16.5C6 14.0147 8.01472 12 10.5 12C12.9853 12 15 14.0147 15 16.5Z"
        fill="white"
      />
      <path
        d="M25.96 16.48C25.96 18.9542 23.9542 20.96 21.48 20.96C19.0058 20.96 17 18.9542 17 16.48C17 14.0058 19.0058 12 21.48 12C23.9542 12 25.96 14.0058 25.96 16.48Z"
        fill="white"
      />
      <path
        d="M10.88 12C8.74 12 7 13.74 7 15.88C7 18.02 8.74 19.76 10.88 19.76C13.02 19.76 14.76 18.02 14.76 15.88C14.76 13.74 13.02 12 10.88 12Z"
        fill="#402A32"
      />
      <path
        d="M20.88 12C18.74 12 17 13.74 17 15.88C17 18.02 18.74 19.76 20.88 19.76C23.02 19.76 24.76 18.02 24.76 15.88C24.76 13.74 23.02 12 20.88 12Z"
        fill="#402A32"
      />
      <path
        d="M13.1626 15.9369C13.908 15.6999 14.2117 14.8666 13.8436 14.0716C13.4755 13.2842 12.5828 12.8255 11.8374 13.0625C11.092 13.2995 10.7883 14.1328 11.1564 14.9278C11.5245 15.7228 12.4172 16.1739 13.1626 15.9369Z"
        fill="white"
      />
      <path
        d="M23.1626 15.9369C23.908 15.6999 24.2117 14.8666 23.8436 14.0716C23.4755 13.2842 22.5736 12.8255 21.8374 13.0625C21.092 13.2995 20.7883 14.1328 21.1564 14.9278C21.5245 15.7228 22.4172 16.1739 23.1626 15.9369Z"
        fill="white"
      />
      <path
        d="M8.95171 9.19985C9.49215 8.72518 9.82675 8.0733 10.0174 7.36941C10.0896 7.10287 10.3642 6.94532 10.6307 7.01751C10.8973 7.0897 11.0548 7.3643 10.9826 7.63084C10.7577 8.46133 10.3423 9.30946 9.61161 9.9512C8.87301 10.5999 7.85473 11.0001 6.5 11.0001C6.22386 11.0001 6 10.7763 6 10.5001C6 10.224 6.22386 10.0001 6.5 10.0001C7.64527 10.0001 8.4192 9.66754 8.95171 9.19985Z"
        fill="#402A32"
      />
      <path
        d="M14.8961 25.4454C14.8941 25.4483 14.8936 25.449 14.8944 25.4473C14.6474 25.9413 14.0468 26.1415 13.5528 25.8946C13.0588 25.6476 12.8586 25.0469 13.1056 24.5529C13.4341 23.8959 14.4046 23.0001 16 23.0001C17.5954 23.0001 18.5659 23.8959 18.8944 24.5529C19.1414 25.0469 18.9412 25.6476 18.4472 25.8946C17.9532 26.1415 17.3526 25.9413 17.1056 25.4473C17.1057 25.4475 17.1059 25.4481 17.1056 25.4473L17.1039 25.4454C17.091 25.4274 17.018 25.3247 16.8527 25.2201C16.6796 25.1106 16.4061 25.0001 16 25.0001C15.5939 25.0001 15.3204 25.1106 15.1473 25.2201C14.982 25.3247 14.909 25.4274 14.8961 25.4454Z"
        fill="#402A32"
      />
      <path
        d="M21.9826 7.36941C22.1733 8.0733 22.5079 8.72518 23.0483 9.19985C23.5808 9.66754 24.3547 10.0001 25.5 10.0001C25.7761 10.0001 26 10.224 26 10.5001C26 10.7763 25.7761 11.0001 25.5 11.0001C24.1453 11.0001 23.127 10.5999 22.3884 9.9512C21.6577 9.30946 21.2423 8.46133 21.0174 7.63084C20.9452 7.3643 21.1027 7.0897 21.3693 7.01751C21.6358 6.94532 21.9104 7.10287 21.9826 7.36941Z"
        fill="#402A32"
      />
    </svg>
  );
};
